import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "../../box/src";
import { BreadcrumbItem } from './BreadcrumbItem';
import { FONTS, SIZES } from './constants';
export const Breadcrumb = ({ breadcrumbItems = [], divider = '>', font = 'regular', hasUnderline = false, size = 's', tailing = false, }) => {
    const fontStyle = `${SIZES[size]}-${FONTS[font]}`;
    const hasDivider = (index) => tailing || index + 1 < breadcrumbItems.length;
    return (_jsx(Box, { flexWrap: "wrap", children: breadcrumbItems.map((tab, index) => (_jsxs(Box, { children: [_jsx(BreadcrumbItem, { fontStyle: fontStyle, hasUnderline: hasUnderline, tab: tab }), hasDivider(index) && (_jsx(Box, { font: fontStyle, px: 2, children: divider }))] }, index))) }));
};
//# sourceMappingURL=Breadcrumb.js.map